const translations = {
    fr: {
        translation: {
            loading: "Chargement",
            address: "Adresse de la borne",
            choose_connector: "Choisissez une prise",
            your_connector: "Votre prise",
            connector: "Connecteur {{number}}",
            available: "Disponible",
            unavailable: "Indisponible",
            next: "Suivant",
            vehicle_plugged: "véhicule branché",

            // Messages de traitement
            processing: {
                initializing: "Initialisation du paiement...",
                verifying: "Vérification en cours...",
                creatingPayment: "Création du moyen de paiement...",
                setupPayment: "Configuration du paiement...",
                confirmingPayment: "Confirmation du paiement...",
                authorizing: "Autorisation en cours...",
                startingCharge: "Démarrage de la charge..."
            },

            // Paiement
            recapitulation: "Récapitulatif de votre session",
            Tarif: "Tarif",
            pay: "Payer",
            email: "Adresse e-mail",
            enterEmail: "Entrez votre adresse e-mail",
            securePayment: "Paiement 100% sécurisé",
            pleaseWait: "Veuillez patienter ...",
            paymentPreparing: "Préparation du paiement ...",
            plugBeforePayment: "Assurez-vous d'avoir branché votre véhicule avant de lancer la recharge.",
            emailLabel: "Adresse e-mail*",
            emailHelp: "Votre e-mail est requis pour recevoir le reçu.",
            cardNumber: "Numéro de carte*",
            ccv: "CCV*",
            exp: "Date d'expiration*",
            preAuthButton: "Pré-autorisation (40€)",
            preAuthNotice: "Une <0>pré-autorisation de 40 €</0> sera effectuée, mais seul le montant exact de votre recharge sera prélevé. Le solde non utilisé sera automatiquement libéré sous 24h.",
            chargeLimitNotice: "Votre recharge s'arrêtera lorsqu'elle atteindra le montant de 40 €.",
            missingPaymentId: "Données manquantes : ID de paiement introuvable",
            modalTitle: "Votre véhicule est-il branché ?",
            cancel: "Annuler",
            confirmationModalTitle: "Vous devez brancher votre véhicule avant de lancer la recharge.",
            notYet: "Ce n'est pas fait",
            done: "C'est fait",
            yes: "Oui",
            no: "Non",
            cardInformation: "Informations de la carte",
            payButton: "Payer",
            paymentNotice: "Vos informations de paiement sont sécurisées et ne seront pas stockées.",

            // Infos
            preAuthValidated: "Pré-autorisation validée",
            chargingWillStart: "Votre recharge va commencer",
            startCharging: "Lancer la recharge",

            startCharging: {
                launching: "Lancement de la recharge ...",
                launched: "Recharge lancée",
                ended: "Recharge terminée",
                wantInvoice: "Je souhaite recevoir une facture",
                detailsSaved: "Coordonnées enregistrées",
                thankYou: "Merci",
                invoiceMessage: "Vous recevrez une facture à la fin de la recharge",
                firstName: "Nom*",
                lastName: "Prénom*",
                address: "Adresse*",
                validate: "Valider",
                chargingStation: "Borne de recharge",
                connector: "Connecteur",
                transactionInfo: "Informations de la transaction",
                status: "Statut",
                energy: "Énergie consommée",
                duration: "Durée",
                chargeEnded: "Charge terminée",
                chargeInProgress: "En charge",
                stopCharge: "Arrêter la charge",
                stoppingCharge: "Arrêt en cours...",
                confirmStopCharge: "Confirmer l'arrêt de la charge",
                confirmStopChargeMessage: "Êtes-vous sûr de vouloir arrêter la charge ? Cette action ne peut pas être annulée.",
                unlockConnector: "Débloquer le câble",
                unlocking: "Déblocage en cours...",
                confirmUnlock: "Confirmer le Déblocage",
                confirmUnlockMessage: "Êtes-vous sûr de vouloir débloquer le câble ?",
                cancel: "Annuler",
                confirm: "Confirmer",
                errors: {
                    firstNameRequired: "Nom obligatoire",
                    lastNameRequired: "Prénom obligatoire",
                    addressRequired: "Adresse obligatoire",
                    missingInfo: "Informations manquantes",
                    missingInfoMessage: "Les informations nécessaires pour démarrer une session de charge sont manquantes. Veuillez réessayer depuis le début.",
                    missingStopInfo: "Informations manquantes pour arrêter la charge",
                },
                apiError: "❌ Une erreur est survenue. Veuillez réessayer.",
            },
            downloadApp: {
                title: "Gérez vos recharges plus simplement avec notre application mobile",
                description: "Suivez vos recharges, consultez vos factures et retrouvez facilement les bornes autour de vous, directement depuis votre smartphone.",
                downloadButton: "Télécharger l'application",
                continueWithoutApp: "Continuer sans l'application",
                features: {
                    feature1: "Rechargez en un clic",
                    feature2: "Suivez votre consommation",
                    feature3: "Trouvez toutes les bornes",
                    feature4: "Bénéficiez d'offres exclusives"
                }
            },

            // Erreurs
            errorTitle: "Erreur !",
            genericErrorTitle: "Une erreur est survenue",
            genericErrorMessage: "Erreur lors de la création de votre autorisation. Veuillez réessayer, s'il vous plaît.",
            errorIconAlt: "Icône d'erreur",
            pageNotFound: "Page non trouvée ou numéro de série invalide",
            noBorneData: "Données de la borne manquantes.",
            errors: {
                // Erreurs HTTP
                badRequest: "La requête est invalide. Veuillez vérifier les informations saisies.",
                unauthorized: "Vous n'êtes pas autorisé à effectuer cette action. Veuillez vous reconnecter.",
                forbidden: "Accès refusé. Vous n'avez pas les permissions nécessaires.",
                notFound: "La ressource demandée n'a pas été trouvée.",
                requestTimeout: "La demande a expiré. Veuillez réessayer.",
                conflict: "Un conflit a été détecté. Veuillez actualiser la page et réessayer.",
                validationError: "Les données saisies sont invalides. Veuillez vérifier les champs.",
                tooManyRequests: "Trop de tentatives. Veuillez réessayer plus tard.",
                serverError: "Le serveur rencontre un problème technique. Veuillez réessayer plus tard.",
                badGateway: "Un problème de communication entre serveurs est survenu. Veuillez réessayer plus tard.",
                serviceUnavailable: "Le service est temporairement indisponible. Veuillez réessayer plus tard.",
                gatewayTimeout: "Le délai d'attente du serveur a été dépassé. Veuillez réessayer plus tard.",

                // Erreurs générales
                networkError: "Problème de connexion réseau. Vérifiez votre connexion Internet et réessayez.",
                unknownError: "Une erreur inattendue est survenue. Veuillez réessayer plus tard.",
                methodNotAllowed: "La méthode de requête n'est pas autorisée pour cette ressource.",
                invoiceError: "Une erreur est survenue lors de l'envoi de la facture. Veuillez réessayer.",
                chargingStationNotFound: "Borne non trouvée",

                // Erreurs spécifiques
                stripeError: "Une erreur est survenue lors du traitement de votre paiement. Veuillez vérifier vos informations et réessayer.",
                recaptchaFailed: "La vérification de sécurité a échoué. Veuillez réessayer.",
                recaptchaExpired: "La vérification de sécurité a expiré. Veuillez réessayer.",
                chargingFailed: "Le démarrage de la charge a échoué. Veuillez réessayer ou contacter le support.",

                invalidResponse: "Erreur réseau ou réponse invalide du serveur",
                authorizationFailed: "Échec de création de l'autorisation de paiement.",
                paymentInitFailed: "Nous n'avons pas pu initialiser le paiement sécurisé. Veuillez réessayer.",
                insufficientFunds: "Vous ne pouvez pas utiliser cette carte car le solde est insuffisant. Veuillez essayer avec une autre carte.",
                errorAttachingPayment: "Une erreur est survenue lors de l'enregistrement de votre moyen de paiement. Veuillez réessayer.",
                cardDeclined: "Votre carte a été refusée. Veuillez vérifier vos informations ou utiliser une autre carte.",
                expiredCard: "Votre carte a expiré. Veuillez utiliser une carte valide.",
                incorrectCvv: "Le code de sécurité (CVV) est incorrect. Veuillez vérifier et réessayer.",
                processingError: "Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer.",
                emailRequired: "Veuillez renseigner votre adresse e-mail.",
                emailInvalid: "Veuillez entrer une adresse email valide",
                invalidEmail: "Veuillez entrer une adresse e-mail valide.",
                apiError: "❌ Une erreur est survenue. Veuillez réessayer.",

                stripeCustomerNotFound: "Nous n'avons pas pu trouver votre client Stripe et n'avons pas pu en créer un nouveau",
                countryNotFound: "Le pays spécifié n'a pas été trouvé",
                postalCodeNotFound: "Le code postal spécifié n'a pas été trouvé",
                noOngoingTransaction: "Aucune transaction en cours trouvée pour cet utilisateur",
                transactionClosed: "Cette transaction a déjà été clôturée",
                noAuthorizationFound: "Aucune autorisation de carte de crédit trouvée pour cette transaction",
                authorizationNotFound: "L'autorisation spécifiée n'a pas été trouvée",
                authorizationNotFoundInDB: "L'autorisation spécifiée n'a pas été trouvée dans la base de données",
                updatingAuthorizationError: "Une erreur est survenue lors de la mise à jour de l'autorisation",
                noDefaultCreditCard: "L'utilisateur n'a pas de carte de crédit par défaut",
                evcpNotFound: "La borne de recharge spécifiée n'a pas été trouvée",
                connectorNotFound: "Le connecteur spécifié n'a pas été trouvé sur cette borne",
                useridTagNotFound: "L'identifiant utilisateur n'a pas été trouvé",
                failedAssociateUser: "Échec de l'association de l'utilisateur",
                internalError: "Erreur interne. Veuillez réessayer",
                noOngoingCpSession: "Aucune session de charge en cours pour cet utilisateur. Vérifiez que la borne est en ligne et que votre session est valide",
                remoteStartDenied: "Démarrage à distance refusé",
                kafkaError: "Erreur inattendue lors de l'envoi à Kafka",
                transactionNotAssociated: "La transaction n'est pas associée à la borne spécifiée",
                cpDisconnected: "La borne de recharge est déconnectée",

            },
            access_denied_no_session: "Accès refusé : aucune session de recharge trouvée.",
            notEligibleForOneClick: "Cette borne n'est pas éligible au Scan to Charge. Veuillez télécharger notre application pour continuer.",
            storeRedirect: {
                downloadTitle: "Téléchargez notre application",
                downloadDescription: "Pour une meilleure expérience, téléchargez l'application Qovoltis."
            },
            resumeSession: {
                title: "Reprise de session",
                sessionActive: "Une recharge est en cours sur cette borne.",
                cardLabel: "Saisissez les 4 derniers chiffres de la carte utilisée",
                validate: "Valider",
                verifying: "Vérification...",
                errors: {
                    invalidFormat: "Veuillez saisir les 4 derniers chiffres de votre carte.",
                    wrongCard: "Code incorrect. Il vous reste {{count}} tentative(s).",
                    tooManyAttempts: "Trop de tentatives. Veuillez réessayer plus tard.",
                    missingInfo: "Informations de session manquantes.",
                    invalidLink: "Ce lien est invalide ou a expiré.",
                    generic: "Une erreur est survenue. Veuillez réessayer."
                }
            },
            chargingStarted: "Recharge démarrée avec succès",
            chargingStationInfo: "Informations de la borne",
            connectorInfo: "Informations du connecteur"
        }
    },
    en: {
        translation: {
            loading: "Loading",
            address: "Station address",
            choose_connector: "Choose a plug",
            your_connector: "Your plug",
            connector: "Connector {{number}}",
            available: "Available",
            unavailable: "Unavailable",
            next: "Next",
            vehicle_plugged: "vehicle plugged",

            // Processing messages
            processing: {
                initializing: "Initializing payment...",
                verifying: "Verification in progress...",
                creatingPayment: "Creating payment method...",
                setupPayment: "Setting up payment...",
                confirmingPayment: "Confirming payment...",
                authorizing: "Authorizing...",
                startingCharge: "Starting charge..."
            },

            // Payment
            recapitulation: "Session Summary",
            Tarif: "Pricing",
            pay: "Pay",
            email: "Email address",
            enterEmail: "Enter your email address",
            securePayment: "100% secure payment",
            pleaseWait: "Please wait ...",
            paymentPreparing: "Preparing payment ...",
            plugBeforePayment:
                "Make sure your vehicle is plugged in before starting charge.",
            emailLabel: "Email address is required",
            emailHelp: "Your email is needed to receive receipt.",
            cardNumber: "Card number",
            ccv: "CCV*",
            exp: "EXP",
            preAuthButton: "Pre-authorization (€40)",
            preAuthNotice:
                "A <0>pre-authorization of €40</0> will be temporarily blocked. Only the exact amount of your charging session will be debited. The remainder will be released within 72 working hours.",
            chargeLimitNotice: "Your charging session will stop if it reaches the amount of €40.",
            missingPaymentId: "Missing data: payment ID not found.",
            modalTitle: "Is your vehicle plugged in?",
            cancel: "Cancel",
            confirmationModalTitle: "You must plug in your vehicle before starting charging.",
            notYet: "Not yet done",
            done: "Done",
            yes: "Yes",
            no: "No",
            cardInformation: "Card information",
            payButton: "Pay",
            paymentNotice: "Your payment information is secure and will not be stored.",

            // Infos
            preAuthValidated: "Pre-authorization validated",
            chargingWillStart: "Your charging session will start",
            startCharging: "Start charging",

            startCharging: {
                launching: "Starting charging ...",
                launched: "Charging launched",
                ended: "Charging ended",
                wantInvoice: "I want to receive an invoice",
                detailsSaved: "Details saved",
                thankYou: "Thank you",
                invoiceMessage: "You will receive an invoice at the end of the charging session",
                firstName: "Last name*",
                lastName: "First name*",
                address: "Address*",
                validate: "Validate",
                chargingStation: "Charging station",
                connector: "Connector",
                transactionInfo: "Transaction Information",
                status: "Status",
                energy: "Energy Consumed",
                duration: "Duration",
                chargeEnded: "Charge ended",
                chargeInProgress: "Charging",
                stopCharge: "Stop charging",
                stoppingCharge: "Stopping...",
                confirmStopCharge: "Confirm stop charging",
                confirmStopChargeMessage: "Are you sure you want to stop charging? This action cannot be undone.",
                unlockConnector: "Unlock the cable",
                unlocking: "Unlocking the cable...",
                confirmUnlock: "Confirm Unlock",
                confirmUnlockMessage: "Are you sure you want to unlock the cable?",
                cancel: "Cancel",
                confirm: "Confirm",
                errors: {
                    firstNameRequired: "Last name is required",
                    lastNameRequired: "First name is required",
                    addressRequired: "Address is required",
                    missingInfo: "Missing information",
                    missingInfoMessage: "The necessary information to start a charging session is missing. Please try again from the beginning.",
                    missingStopInfo: "Missing information to stop charging",
                },
                apiError: "❌ An error occurred. Please try again.",
            },
            downloadApp: {
                title: "Manage your charging sessions more easily with our mobile app",
                description: "Track your charging sessions, view your invoices, and easily find charging stations near you, directly from your smartphone.",
                downloadButton: "Download app",
                continueWithoutApp: "Continue without app",
                features: {
                    feature1: "Charge with one click",
                    feature2: "Track your consumption",
                    feature3: "Find all charging stations",
                    feature4: "Get exclusive offers"
                }
            },

            // Errors
            errorTitle: "Error!",
            genericErrorTitle: "An error has occurred",
            genericErrorMessage:
                "Error while creating your authorization. Please try again.",
            errorIconAlt: "Error icon",
            pageNotFound: "Page not found or invalid serial number",
            noBorneData: "Missing charging station data.",
            errors: {
                // HTTP Errors
                badRequest: "The request is invalid. Please check the entered information.",
                unauthorized: "You are not authorized to perform this action. Please log in again.",
                forbidden: "Access denied. You do not have the necessary permissions.",
                notFound: "The requested resource was not found.",
                requestTimeout: "The request has timed out. Please try again.",
                conflict: "A conflict has been detected. Please refresh the page and try again.",
                validationError: "The entered data is invalid. Please check the fields.",
                tooManyRequests: "Too many attempts. Please try again later.",
                serverError: "The server is experiencing a technical problem. Please try again later.",
                badGateway: "A communication problem between servers has occurred. Please try again later.",
                serviceUnavailable: "The service is temporarily unavailable. Please try again later.",
                gatewayTimeout: "The server took too long to respond. Please try again later.",

                // General Errors
                networkError: "Network connection problem. Check your internet connection and try again.",
                unknownError: "An unexpected error has occurred. Please try again later.",
                methodNotAllowed: "The request method is not allowed for this resource.",
                invoiceError: "An error occurred while sending the invoice. Please try again.",
                chargingStationNotFound: "Charging station not found",

                // Specific Errors
                stripeError: "An error occurred while processing your payment. Please check your information and try again.",
                recaptchaFailed: "The security verification failed. Please try again.",
                recaptchaExpired: "The security verification has expired. Please try again.",
                chargingFailed: "Starting the charge failed. Please try again or contact support.",

                invalidResponse: "Network error or invalid server response.",
                authorizationFailed: "Failed to create payment authorization.",
                paymentInitFailed: "We couldn't initialize the secure payment. Please try again.",
                insufficientFunds: "This card cannot be used due to insufficient funds. Please try using another card.",
                errorAttachingPayment: "An error occurred while saving your payment method. Please try again.",
                cardDeclined: "Your card was declined. Please check your information or use another card.",
                expiredCard: "Your card has expired. Please use a valid card.",
                incorrectCvv: "The security code (CVV) is incorrect. Please check and try again.",
                processingError: "An error occurred while processing your request. Please try again.",
                emailRequired: "Please enter your email address.",
                emailInvalid: "Please enter a valid email address",
                invalidEmail: "Please enter a valid email address.",
                apiError: "❌ An error occurred. Please try again.",


                stripeCustomerNotFound: "We could not find your Stripe customer and could not create a new one",
                countryNotFound: "The specified country was not found",
                postalCodeNotFound: "The specified postal code was not found",
                noOngoingTransaction: "No ongoing transaction found for this user",
                transactionClosed: "This transaction has already been closed",
                noAuthorizationFound: "No credit card authorization found for this transaction",
                authorizationNotFound: "The specified authorization was not found",
                authorizationNotFoundInDB: "The specified authorization was not found in the database",
                updatingAuthorizationError: "An error occurred while updating the authorization",
                noDefaultCreditCard: "User has no default credit card",
                evcpNotFound: "The specified charging station was not found",
                connectorNotFound: "The specified connector was not found on this station",
                useridTagNotFound: "User identifier not found",
                failedAssociateUser: "Failed to associate user",
                internalError: "Internal error. Please try again",
                noOngoingCpSession: "No ongoing charging session for this user. Please check if the station is online and if your session is valid",
                remoteStartDenied: "Remote start denied",
                kafkaError: "Unexpected error sending to Kafka",
                transactionNotAssociated: "The transaction is not associated with the specified station",
                cpDisconnected: "The charging station is disconnected",

            },
            access_denied_no_session: "Access denied: no charging session found.",
            notEligibleForOneClick: "This station is not eligible for Scan to Charge. Please download our app to continue.",
            storeRedirect: {
                downloadTitle: "Download our app",
                downloadDescription: "For a better experience, download the Qovoltis app."
            },
            resumeSession: {
                title: "Resume session",
                sessionActive: "A charging session is in progress on this station.",
                cardLabel: "Enter the last 4 digits of the card you used",
                validate: "Verify",
                verifying: "Verifying...",
                errors: {
                    invalidFormat: "Please enter the last 4 digits of your card.",
                    wrongCard: "Incorrect code. You have {{count}} attempt(s) left.",
                    tooManyAttempts: "Too many attempts. Please try again later.",
                    missingInfo: "Missing session information.",
                    invalidLink: "This link is invalid or has expired.",
                    generic: "Something went wrong. Please try again."
                }
            },
            chargingStarted: "Charging started successfully",
            chargingStationInfo: "Charging station information",
            connectorInfo: "Connector information"
        }
    },
    es: {
        translation: {
            loading: "Cargando",
            address: "Dirección de la estación",
            choose_connector: "Elija un enchufe",
            your_connector: "Su enchufe",
            connector: "Conector {{number}}",
            available: "Disponible",
            unavailable: "No disponible",
            next: "Siguiente",
            vehicle_plugged: "vehículo conectado",

            // Mensajes de procesamiento
            processing: {
                initializing: "Inicializando pago...",
                verifying: "Verificación en curso...",
                creatingPayment: "Creando método de pago...",
                setupPayment: "Configurando pago...",
                confirmingPayment: "Confirmando pago...",
                authorizing: "Autorizando...",
                startingCharge: "Iniciando carga..."
            },

            // Pago
            recapitulation: "Resumen de su sesión",
            Tarif: "Precio",
            pay: "Pagar",
            email: "Correo electrónico",
            enterEmail: "Ingrese su dirección de correo electrónico",
            securePayment: "Pago 100% seguro",
            pleaseWait: "Por favor espere ...",
            paymentPreparing: "Preparando el pago ...",
            plugBeforePayment:
                "Asegúrese de conectar su vehículo antes de iniciar la recarga.",
            emailLabel: "El correo electrónico es obligatorio",
            emailHelp: "Su correo electrónico es necesario para recibir el recibo.",
            cardNumber: "Número de tarjeta",
            ccv: "CCV*",
            exp: "EXP*",
            preAuthButton: "Preautorización (40 €)",
            preAuthNotice:
                "Es necesaria una <0>autorización previa de 40 €</0> a su tarjeta, pero solo se cobrará el importe exacto de su recarga. El saldo no usado se liberará en un plazo de 24 horas.",
            chargeLimitNotice: "Su recarga se detendrá si alcanza el importe de 40€.",
            missingPaymentId: "Datos faltantes: ID de pago no encontrado.",
            modalTitle: "¿Está su vehículo conectado?",
            cancel: "Cancelar",
            confirmationModalTitle: "Debe conectar su vehículo antes de iniciar la carga.",
            notYet: "Aún no está hecho",
            done: "Ya está hecho",
            yes: "Sí",
            no: "No",
            cardInformation: "Información de la tarjeta",
            payButton: "Pagar",
            paymentNotice: "Su información de pago es segura y no será almacenada.",

            // Infos
            preAuthValidated: "Preautorización validada",
            chargingWillStart: "Su recarga va a comenzar",
            startCharging: "Iniciar recarga",

            startCharging: {
                launching: "Iniciando la recarga ...",
                launched: "Carga iniciada",
                ended: "Recarga finalizada",
                wantInvoice: "Quiero recibir una factura",
                detailsSaved: "Datos guardados",
                thankYou: "Gracias",
                invoiceMessage: "Recibirá una factura al final de la recarga",
                firstName: "Apellido*",
                lastName: "Nombre*",
                address: "Dirección*",
                validate: "Validar",
                chargingStation: "Estación de carga",
                connector: "Conector",
                transactionInfo: "Información de la transacción",
                status: "Estado",
                energy: "Energía consumida",
                duration: "Duración",
                chargeEnded: "Carga finalizada",
                chargeInProgress: "Cargando",
                stopCharge: "Detener carga",
                stoppingCharge: "Deteniendo...",
                confirmStopCharge: "Confirmar detención de carga",
                confirmStopChargeMessage: "¿Está seguro de que desea detener la carga? Esta acción no se puede deshacer.",
                unlockConnector: "Desbloquear el cable",
                unlocking: "Desbloqueando el cable...",
                confirmUnlock: "Confirmar desbloqueo",
                confirmUnlockMessage: "¿Está seguro de que desea desbloquear el cable?",
                cancel: "Cancelar",
                confirm: "Confirmar",
                errors: {
                    firstNameRequired: "Apellido obligatorio",
                    lastNameRequired: "Nombre obligatorio",
                    addressRequired: "Dirección obligatoria",
                    missingInfo: "Información faltante",
                    missingInfoMessage: "La información necesaria para iniciar una sesión de carga está faltando. Por favor, intente nuevamente desde el principio.",
                    missingStopInfo: "Información faltante para detener la carga",
                },
                apiError: "❌ Ocurrió un error. Por favor, inténtelo de nuevo.",
            },
            downloadApp: {
                title: "Gestiona tus recargas de forma más sencilla con nuestra aplicación móvil",
                description: "Sigue tus recargas, consulta tus facturas y encuentra fácilmente estaciones de carga cerca de ti, directamente desde tu smartphone.",
                downloadButton: "Descargar la aplicación",
                continueWithoutApp: "Continuar sin la aplicación",
                features: {
                    feature1: "Cargue con un clic",
                    feature2: "Siga su consumo",
                    feature3: "Encuentre todas las estaciones",
                    feature4: "Obtenga ofertas exclusivas"
                }
            },

            // Errores
            errorTitle: "¡Error!",
            genericErrorTitle: "Ha ocurrido un error",
            genericErrorMessage:
                "Error al crear su autorización. Por favor, inténtelo de nuevo.",
            errorIconAlt: "Icono de error",
            pageNotFound: "Página no encontrada o número de serie no válido",
            noBorneData: "Faltan datos de la estación de carga.",
            errors: {
                // Errores HTTP
                badRequest: "La solicitud es inválida. Por favor, verifique la información ingresada.",
                unauthorized: "No está autorizado para realizar esta acción. Por favor, inicie sesión de nuevo.",
                forbidden: "Acceso denegado. No tiene los permisos necesarios.",
                notFound: "El recurso solicitado no fue encontrado.",
                requestTimeout: "La solicitud ha expirado. Por favor, inténtelo de nuevo.",
                conflict: "Se ha detectado un conflicto. Por favor, actualice la página e inténtelo de nuevo.",
                validationError: "Los datos ingresados son inválidos. Por favor, verifique los campos.",
                tooManyRequests: "Demasiados intentos. Por favor, inténtelo más tarde.",
                serverError: "El servidor está experimentando un problema técnico. Por favor, inténtelo más tarde.",
                badGateway: "Ha ocurrido un problema de comunicación entre servidores. Por favor, inténtelo más tarde.",
                serviceUnavailable: "El servicio no está disponible temporalmente. Por favor, inténtelo más tarde.",
                gatewayTimeout: "El servidor tardó demasiado en responder. Por favor, inténtelo de nuevo.",

                // Errores Generales
                networkError: "Problema de conexión de red. Verifique su conexión a internet e inténtelo de nuevo.",
                unknownError: "Ha ocurrido un error inesperado. Por favor, inténtelo más tarde.",
                methodNotAllowed: "El método de solicitud no está permitido para este recurso.",
                invoiceError: "Ocurrió un error al enviar la factura. Por favor, inténtelo de nuevo.",
                chargingStationNotFound: "Estación de carga no encontrada",

                // Errores Específicos
                stripeError: "Ocurrió un error al procesar su pago. Por favor, verifique su información e inténtelo de nuevo.",
                recaptchaFailed: "La verificación de seguridad falló. Por favor, inténtelo de nuevo.",
                recaptchaExpired: "La verificación de seguridad ha expirado. Por favor, inténtelo de nuevo.",
                chargingFailed: "El inicio de la carga falló. Por favor, inténtelo de nuevo o contacte con soporte.",

                // Mensajes Existentes
                invalidResponse: "Error de red o respuesta no válida del servidor.",
                authorizationFailed: "Error al crear la autorización de pago.",
                paymentInitFailed: "No pudimos inicializar el pago seguro. Por favor, inténtelo de nuevo.",
                insufficientFunds: "No se puede usar esta tarjeta porque no tiene fondos suficientes. Por favor, intente con otra tarjeta.",
                errorAttachingPayment: "Ocurrió un error al guardar su método de pago. Por favor, inténtelo de nuevo.",
                cardDeclined: "Su tarjeta fue rechazada. Por favor, verifique su información o use otra tarjeta.",
                expiredCard: "Su tarjeta ha caducado. Por favor, use una tarjeta válida.",
                incorrectCvv: "El código de seguridad (CVV) es incorrecto. Por favor, verifique e inténtelo de nuevo.",
                processingError: "Ocurrió un error al procesar su solicitud. Por favor, inténtelo de nuevo.",
                emailRequired: "Por favor, introduzca su dirección de correo electrónico.",
                emailInvalid: "Por favor ingrese un correo electrónico válido",
                invalidEmail: "Por favor ingrese un correo electrónico válido.",
                apiError: "❌ Ha ocurrido un error. Inténtelo de nuevo.",


                stripeCustomerNotFound: "No pudimos encontrar su cliente Stripe y no pudimos crear uno nuevo",
                countryNotFound: "El país especificado no fue encontrado",
                postalCodeNotFound: "El código postal especificado no fue encontrado",
                noOngoingTransaction: "No se encontró ninguna transacción en curso para este usuario",
                transactionClosed: "Esta transacción ya ha sido cerrada",
                noAuthorizationFound: "No se encontró autorización de tarjeta de crédito para esta transacción",
                authorizationNotFound: "La autorización especificada no fue encontrada",
                authorizationNotFoundInDB: "La autorización especificada no fue encontrada en la base de datos",
                updatingAuthorizationError: "Ocurrió un error al actualizar la autorización",
                noDefaultCreditCard: "El usuario no tiene tarjeta de crédito predeterminada",
                evcpNotFound: "La estación de carga especificada no fue encontrada",
                connectorNotFound: "El conector especificado no fue encontrado en esta estación",
                useridTagNotFound: "Identificador de usuario no encontrado",
                failedAssociateUser: "Error al asociar usuario",
                internalError: "Error interno. Por favor inténtelo de nuevo",
                noOngoingCpSession: "No hay sesión de carga en curso para este usuario. Verifique si la estación está en línea y si su sesión es válida",
                remoteStartDenied: "Inicio remoto denegado",
                kafkaError: "Error inesperado al enviar a Kafka",
                transactionNotAssociated: "La transacción no está asociada con la estación especificada",
                cpDisconnected: "La estación de carga está desconectada",

            },
            access_denied_no_session: "Acceso denegado: no se encontró ninguna sesión de carga.",
            notEligibleForOneClick: "Esta estación no es elegible para Scan to Charge. Por favor descargue nuestra aplicación para continuar.",
            storeRedirect: {
                downloadTitle: "Descargue nuestra aplicación",
                downloadDescription: "Para una mejor experiencia, descargue la aplicación Qovoltis."
            },
            resumeSession: {
                title: "Reanudar sesión",
                sessionActive: "Hay una recarga en curso en esta estación.",
                cardLabel: "Introduzca los últimos 4 dígitos de la tarjeta utilizada",
                validate: "Validar",
                verifying: "Verificando...",
                errors: {
                    invalidFormat: "Introduzca los últimos 4 dígitos de su tarjeta.",
                    wrongCard: "Código incorrecto. Le quedan {{count}} intento(s).",
                    tooManyAttempts: "Demasiados intentos. Inténtelo de nuevo más tarde.",
                    missingInfo: "Falta información de la sesión.",
                    invalidLink: "Este enlace no es válido o ha caducado.",
                    generic: "Se ha producido un error. Inténtelo de nuevo."
                }
            },
            chargingStarted: "Carga iniciada con éxito",
            chargingStationInfo: "Información de la estación de carga",
            connectorInfo: "Información del conector"
        }
    }
};

export default translations;